module.exports = __webpack_public_path__ + "static/media/iconList.361e720a.svg";